import { render } from "./BubbleNotification.vue?vue&type=template&id=bfcaf2a6"
import script from "./BubbleNotification.vue?vue&type=script&lang=js"
export * from "./BubbleNotification.vue?vue&type=script&lang=js"

import "./BubbleNotification.vue?vue&type=style&index=0&id=bfcaf2a6&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__